import { GameLiveConnection } from '@pascal/pascal-core';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { LiveUpdateConnectionMethod } from './types';
import { liveUpdateService } from '../liveUpdateService';
import { applicationStore } from '../../store/applicationStore';

export class LiveUpdateConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  sendGetInitialState() {
    this.executeGameConnections();
    this.getAllGameLiveBets();
  }

  getAllGameLiveBets() {
    return super.invoke(LiveUpdateConnectionMethod.GetSpins, applicationStore.partnerSkin);
  }

  checkResultHash(params) {
    super.invoke(LiveUpdateConnectionMethod.CheckResultHash, params);
  }

  executeGameConnections() {
    super.on(
      LiveUpdateConnectionMethod.LiveSpin,
      liveUpdateService.handleLiveSpinUpdate.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.SpinsResult,
      liveUpdateService.handleGetAllLiveBets.bind(liveUpdateService)
    );
    super.on(
      LiveUpdateConnectionMethod.CheckResultHashResult,
      liveUpdateService.handleCheckResultHashResult.bind(liveUpdateService)
    );
  }
}

const { liveUpdateSocketUrl } = environmentBuilder();

export const liveUpdateConnection = new LiveUpdateConnection({ url: liveUpdateSocketUrl });
